<template>
  <v-wait for="isFetchingDashboard">
    <core-spinner slot="waiting" />
    <FactorySelector :show-selector="false" />
    <div class="grid-container">
      <ConcreteFormulaList
        class="formula-list"
        :items="concreteTableList"
        :selected-formula="selectedConcreteFormulaId"
        @onFormulaSelected="onFormulaSelected"
      />
      <VariationChart
        id="concreteVariation"
        class="variation-chart"
        :data="variations"
        :title="$t('views.dashboard.variation-chart.title')"
        translation-path="views.dashboard.concrete.params"
        @rowclick="onVariationRowClick"
      />
      <LineBoundaryChart
        id="concreteBoundary"
        class="boundary-chart"
        :show-details-action="false"
        :title="$t('views.dashboard.concrete.illustrated')"
        :subtitle="$t('views.dashboard.concrete.params.' + selectedParam)"
        :boundary-data="timeline.deviations"
        :upper-h-r="timeline.upperHR"
        :upper-a-r="timeline.upperAR"
        :upper-l-r="timeline.upperLR"
        :zero-r="0"
        :lower-l-r="timeline.lowerLR"
        :lower-a-r="timeline.lowerAR"
        :lower-h-r="timeline.lowerHR"
      />
    </div>
  </v-wait>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import VariationChart from '../Charts/Variation.vue'
import LineBoundaryChart from '../Charts/Lines/Boundary.vue'
import ConcreteFormulaList from './ConcreteFormulaList.vue'
import FactorySelector from './FactorySelector.vue'
import { concreteVariations, paramTimeline } from '@/utils/concrete'

export default {
  components: {
    ConcreteFormulaList,
    FactorySelector,
    VariationChart,
    LineBoundaryChart,
  },
  data() {
    return {
      selectedParam: 'air',
    }
  },
  computed: {
    ...mapState('production', [
      'concreteFormulas',
      'selectedConcreteFormulaId',
    ]),
    ...mapGetters('production', [
      'concreteTableList',
      'selectedConcreteFormula',
    ]),
    variations() {
      const f = this.selectedConcreteFormula
      if (!f) return []
      return concreteVariations(f.latest, f.targets)
    },
    timeline() {
      const f = this.selectedConcreteFormula
      if (!f) return paramTimeline(this.selectedParam, [], {})
      return paramTimeline(this.selectedParam, f.samples, f.targets)
    },
  },
  watch: {
    variations: {
      immediate: true,
      handler(vals) {
        if (vals.length && !vals.some((v) => v.id === this.selectedParam)) {
          this.selectedParam = vals[0].id
        }
      },
    },
  },
  async created() {
    this.$wait.start('isFetchingDashboard')

    if (!this.concreteFormulas.length) {
      await this.$store.dispatch(
        'production/fetchConcreteProductionTechnicianDashboard',
      )
    }

    if (this.concreteFormulas.length && !this.selectedConcreteFormulaId) {
      this.$store.commit(
        'production/selectConcreteFormula',
        this.concreteFormulas[0].id,
      )
    }

    this.$wait.end('isFetchingDashboard')
  },
  methods: {
    onFormulaSelected(item) {
      this.$store.commit('production/selectConcreteFormula', item.id)
    },
    onVariationRowClick(e) {
      if (e && e.id) this.selectedParam = e.id
    },
  },
}
</script>

<style scoped>
.formula-list {
  grid-row: 1 / span 6;
  grid-column: 1 / span 12;
}
.variation-chart {
  grid-row: 7 / span 6;
  grid-column: 1 / span 6;
}
.boundary-chart {
  grid-row: 7 / span 6;
  grid-column: 7 / span 6;
}
</style>
